import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { T as o, _ as c, s as u } from "./directive-daf4e9b6-abc0af54.js";
import { w as s, me as a } from "./abstract-base-8edf0a84-e11d45a3.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var e = /*#__PURE__*/function (_c) {
  _inherits(e, _c);
  function e(r) {
    var _this;
    _classCallCheck(this, e);
    if (_this = _possibleConstructorReturn(this, _getPrototypeOf(e).call(this, r)), _this.it = s, r.type !== u.CHILD) throw Error(_this.constructor.directiveName + "() can only be used in child bindings");
    return _possibleConstructorReturn(_this);
  }
  _createClass(e, [{
    key: "render",
    value: function render(r) {
      if (r === s || r == null) return this._t = void 0, this.it = r;
      if (r === a) return r;
      if (typeof r != "string") throw Error(this.constructor.directiveName + "() called with a non-string value");
      if (r === this.it) return this._t;
      this.it = r;
      var t = [r];
      return t.raw = t, this._t = {
        _$litType$: this.constructor.resultType,
        strings: t,
        values: []
      };
    }
  }]);
  return e;
}(c);
e.directiveName = "unsafeHTML", e.resultType = 1;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var i = /*#__PURE__*/function (_e) {
  _inherits(i, _e);
  function i() {
    _classCallCheck(this, i);
    return _possibleConstructorReturn(this, _getPrototypeOf(i).apply(this, arguments));
  }
  return i;
}(e);
i.directiveName = "unsafeSVG", i.resultType = 2;
var d = o(i);
export { d };